module.exports = __webpack_public_path__ + "img/bpm-01.6fdc31af.jpg";